import(/* webpackMode: "eager" */ "/Users/aldy/Downloads/kolabo 3/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/aldy/Downloads/kolabo 3/src/styles/tailwind.css");
